var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import RedeemSIP from "./RedeemSIP";
import SideTxnFooter from "../SideTxnFooter";
import TxnConfirmationScreen from "./TxnConfirmationScreen";
import SWPMain from "../Swp/SwpMain";
import { EMutualFundFlow } from "../MutualFund";
import OrderStatusScreen from "../CommonComp/OrderStatusScreen";
import { MFError } from "../MutualFundConstant";
import { roundUpToThreeDecimalPlaces } from "@domains/utils/numberMethods";
// export interface MFFormData1 {
//   amount: string;
//   isRedeemLongTerm?: boolean;
//   quantity?: number;
//   sipDate?: string;
//   installmentCount?: string;
// }
var RedeemParent = function (props) {
    var _a = __read(React.useState(false), 2), isConfirmModalOpen = _a[0], setIsConfirmModalOpen = _a[1];
    var _b = __read(useState(false), 2), isShowErrorScreen = _b[0], setIsShowErrorScreen = _b[1];
    var _c = __read(useState(), 2), orderStatus = _c[0], setOrderStatus = _c[1];
    var _d = __read(useState({
        amount: { msg: "", status: false },
        installmentCount: { msg: "", status: false },
    }), 2), formErrors = _d[0], setFormErrors = _d[1];
    var checkForError = function () {
        var _a, _b, _c;
        if (!isConfirmModalOpen) {
            switch (props.tocFlow) {
                case EMutualFundFlow.REDEEM:
                    if (formErrors.amount.status || !+((_a = props.purchaseFormData) === null || _a === void 0 ? void 0 : _a.amount)) {
                        return true;
                    }
                    break;
                case EMutualFundFlow.SWP:
                    if (formErrors.installmentCount.status ||
                        !((_b = props.purchaseFormData) === null || _b === void 0 ? void 0 : _b.installmentCount) ||
                        formErrors.amount.status ||
                        !+((_c = props.purchaseFormData) === null || _c === void 0 ? void 0 : _c.amount)) {
                        return true;
                    }
                    break;
            }
        }
        return false;
    };
    var handleRightBtnOnClickForFooter = function () {
        var _a, _b, _c, _d, _e;
        switch (props.tocFlow) {
            case EMutualFundFlow.REDEEM:
                if (formErrors.amount.status || !+((_a = props.purchaseFormData) === null || _a === void 0 ? void 0 : _a.amount)) {
                    return;
                }
                if (props.isModify) {
                    props.modifyOrder();
                }
                break;
            case EMutualFundFlow.SWP:
                if (formErrors.installmentCount.status ||
                    !((_b = props.purchaseFormData) === null || _b === void 0 ? void 0 : _b.installmentCount) ||
                    formErrors.amount.status ||
                    !+((_c = props.purchaseFormData) === null || _c === void 0 ? void 0 : _c.amount)) {
                    return;
                }
                break;
        }
        if (isConfirmModalOpen) {
            if (props.isModify) {
                props.onSubmitModify();
            }
            else
                (_d = props.onSubmit) === null || _d === void 0 ? void 0 : _d.call(props);
            return;
        }
        if (((_e = props.folio) === null || _e === void 0 ? void 0 : _e.redeemAllowed) === "f") {
            setIsShowErrorScreen(true);
            setIsConfirmModalOpen(true);
            setOrderStatus(__assign(__assign({}, MFError.notAllowedFolio(props.tocFlow)), { genericDetails: undefined, genericDetailsCollapse: undefined, children: null }));
            return;
        }
        setIsConfirmModalOpen(true);
        // switch (props.tocFlow) {
        //   case EMutualFundFlow.REDEEM:
        //     if (!formErrors.amount.status && props.purchaseFormData?.amount) {
        //       setIsConfirmModalOpen(true);
        //     }
        //     break;
        //   case EMutualFundFlow.SWP:
        //     if (
        //       !formErrors.installmentCount.status &&
        //       props.purchaseFormData?.installmentCount &&
        //       !formErrors.amount.status &&
        //       props.purchaseFormData?.amount
        //     ) {
        //       setIsConfirmModalOpen(true);
        //     }
        //     break;
        // }
    };
    var handleConfirmModalClose = function () {
        setIsConfirmModalOpen(false);
    };
    var handleBackBtnOnClick = function () {
        setIsConfirmModalOpen(false);
    };
    var getButtonConfig = function () {
        if (isShowErrorScreen) {
            return {
                leftBtnText: "Close",
                leftBtnOnClick: function () {
                    props === null || props === void 0 ? void 0 : props.setShowTOC(false);
                },
                rightBtnText: "Go Back",
                rightBtnOnClick: function () {
                    setIsShowErrorScreen(false);
                    setIsConfirmModalOpen(false);
                },
            };
        }
        if (isConfirmModalOpen) {
            return {
                leftBtnText: "Cancel",
                leftBtnOnClick: function () {
                    props === null || props === void 0 ? void 0 : props.setShowTOC(false);
                },
                rightBtnText: "Confirm",
                rightBtnOnClick: handleRightBtnOnClickForFooter,
            };
        }
        return {
            leftBtnText: "Cancel",
            leftBtnOnClick: function () {
                props === null || props === void 0 ? void 0 : props.setShowTOC(false);
            },
            rightBtnText: props.rightBtnText || "Redeem",
            rightBtnOnClick: handleRightBtnOnClickForFooter,
        };
    };
    var buttonConfig = getButtonConfig();
    var getMinimumRedeemAmount = function () {
        var _a, _b;
        if ((props === null || props === void 0 ? void 0 : props.minRedQty) && ((_a = props.folio) === null || _a === void 0 ? void 0 : _a.nav) && (props === null || props === void 0 ? void 0 : props.minRedAmt)) {
            var minRedQty = Number(props.minRedQty.toString());
            var nav = +((_b = props.folio) === null || _b === void 0 ? void 0 : _b.nav);
            var minRedAmt = Number(props.minRedAmt.toString());
            var calculatedMinRedeemAmount = minRedQty * nav;
            return roundUpToThreeDecimalPlaces(Math.max(calculatedMinRedeemAmount, minRedAmt));
        }
    };
    var renderFlowContent = function () {
        if (isConfirmModalOpen) {
            if (isShowErrorScreen) {
                return React.createElement(OrderStatusScreen, __assign({ hideHeader: true }, orderStatus));
            }
            return (React.createElement(TxnConfirmationScreen, { backBtnOnClick: function () { return setIsConfirmModalOpen(false); }, purchaseFormData: props === null || props === void 0 ? void 0 : props.purchaseFormData, txnType: props.tocFlow || EMutualFundFlow.REDEEM, isModify: props.isModify }));
        }
        switch (props.tocFlow) {
            case EMutualFundFlow.SWP:
                return (React.createElement(SWPMain, { mfHoldingDetail: props === null || props === void 0 ? void 0 : props.mfHoldingDetail, purchaseFormData: props === null || props === void 0 ? void 0 : props.purchaseFormData, redeemValObj: props === null || props === void 0 ? void 0 : props.redeemValObj, setPurchaseFormData: props === null || props === void 0 ? void 0 : props.setPurchaseFormData, formErrors: formErrors, setFormErrors: setFormErrors, startDate: props === null || props === void 0 ? void 0 : props.startDate, schemeName: props === null || props === void 0 ? void 0 : props.schemeName, purchaseAmtMul: props === null || props === void 0 ? void 0 : props.purchaseAmtMul, minRedAmt: props === null || props === void 0 ? void 0 : props.minRedAmt, maxRedAmt: props === null || props === void 0 ? void 0 : props.maxRedAmt, setPhysicalFlag: props === null || props === void 0 ? void 0 : props.setPhysicalFlag, setFolio: props === null || props === void 0 ? void 0 : props.setFolio, folio: props === null || props === void 0 ? void 0 : props.folio }));
            case EMutualFundFlow.REDEEM:
            default:
                return (React.createElement(RedeemSIP, { mfHoldingDetail: props === null || props === void 0 ? void 0 : props.mfHoldingDetail, purchaseFormData: props === null || props === void 0 ? void 0 : props.purchaseFormData, redeemValObj: props === null || props === void 0 ? void 0 : props.redeemValObj, setPurchaseFormData: props === null || props === void 0 ? void 0 : props.setPurchaseFormData, formErrors: formErrors, setFormErrors: setFormErrors, schemeName: props === null || props === void 0 ? void 0 : props.schemeName, setFolio: props === null || props === void 0 ? void 0 : props.setFolio, folio: props === null || props === void 0 ? void 0 : props.folio, minRedAmt: getMinimumRedeemAmount(), maxRedAmt: props === null || props === void 0 ? void 0 : props.maxRedAmt, redAmtMul: props === null || props === void 0 ? void 0 : props.redAmtMul, setPhysicalFlag: props === null || props === void 0 ? void 0 : props.setPhysicalFlag, isModify: props === null || props === void 0 ? void 0 : props.isModify }));
        }
    };
    return (React.createElement("div", { className: "d-flex flex-column height-100" },
        renderFlowContent(),
        React.createElement("div", { className: "bottom-contents mf-footer-contents" },
            React.createElement(SideTxnFooter, { leftBtnText: buttonConfig.leftBtnText, leftBtnOnClick: buttonConfig.leftBtnOnClick, rightBtnText: buttonConfig.rightBtnText, rightBtnOnClick: buttonConfig.rightBtnOnClick, isDisableButton: checkForError() }))));
};
export default RedeemParent;
